export const CHECK_FOR_UPDATE_TOPIC = 'check_for_update_topic';
export const NB_CAMPAIGNS_SEARCH_RESULT_CHANGED_TOPIC = 'nb-results-changed'
export const NB_RECORDS_SEARCH_RESULT_CHANGED_TOPIC = 'nb-results-changed'
export const CLOSE_ITEM_SCREEN_TOPIC = 'close-item-screen-topic'
export const TOGGLE_MENU_TOPIC = 'toggle_menu_topic';
export const FORCE_CLOSE_MENU_TOPIC = 'force_close_menu_topic';
export const SAVE_CURRENT_RECORD_TOPIC = 'save_current_record_topic'
export const SAVE_CURRENT_ITEM_TOPIC = 'save_current_item_topic'
export const DELETE_NOT_SYNCHRONIZED_NEW_ITEM = 'delete_not_synchronized_new_item'
export const DELETE_MODIFICATIONS_NOT_SYNCHRONIZED = 'delete_modifications_not_synchronized'
export const DISPLAY_ALERT_TOPIC = 'display-alert-topic'
export const REPORT_EDITOR_OPEN_ALL_TABS_TOPIC = 'open_section_topic';
export const TRANSITION_RECORD_TO_STATE = 'transition-record-to-validated'
export const OPEN_ADD_ITEM_MODAL = 'open-add_item-modal'
export const PUSH_SYNCHRO_PERFORMED = 'push-synchro-performed'
export const NB_ITEMS_SEARCH_RESULT_CHANGED_TOPIC = 'nb-results-changed'
export const OPEN_AUDIT_CAMPAIGN_POP_UP = 'open-audit-campaign-pop-up'